import type { CarEventType } from './types.ts'

function storageKey(ledgerId: string, type: CarEventType): string {
  return `garage.defaultAccount.${ledgerId}.${type}`
}

/** The category account (expense or income) last used for a given event type, per ledger.
 * No wire field for this exists (AGENTS.md: account names are the user's own, and there is
 * no dedicated capability to invent one for) - it lives per-browser, the same as
 * locale-preference.ts's own setting, seeded the moment a journal entry is actually posted. */
export function readDefaultAccountId(
  ledgerId: string,
  type: CarEventType,
  storage: Storage = window.localStorage,
): string | undefined {
  return storage.getItem(storageKey(ledgerId, type)) ?? undefined
}

export function rememberDefaultAccountId(
  ledgerId: string,
  type: CarEventType,
  accountId: string,
  storage: Storage = window.localStorage,
): void {
  storage.setItem(storageKey(ledgerId, type), accountId)
}
